/**
 * Definition for Color View
 * @module views/ViewColor
 */
import * as THREE from 'three';
import { itemFaceCenter } from './Behaviours';
import config from '../config';

export default {

    /**
     * URI used in URL
     * @type String
     */
    path: '/color/',
    /**
     * is this views cameraIndex limited 0-1?
     * @type boolean
     */
    isFinite: true,
    /**
     * the desiredCameraIndex on view load
     * @type float
     */
    totalRad: 0,
    startCameraNormal: 0.5,
    lastCameraNormal: 0,

    /**
     * @type function
     */
    willMount() {
    },
    /**
     * @param items {Array} Array of Items
     */
    willUnmount(items) {
    },

    /**
     * @param cam {Cam} The Camera Wrapper
     * @param items {Array} Array of Items
     */
    update(cam, items) {

        const { camera, cameraWrap } = cam;
        cameraWrap.rotation.y = this.lastCameraNormal * this.totalRad;
        
        items.forEach((item, i) => itemFaceCenter.call(item));
    },

    /**
     * @param cam {Cam} The Camera Wrapper
     * @param isInitial {boolean} true if items should be placed instantly
     */
    arrangeItems(items, isInitial) {

        items = items.sort((a, b) => {
            return b.props.colorSort - a.props.colorSort;
        });
        
        let totalRad = 0;
        const length = items.length;
        
        items.forEach((item, i) => {
            
            const radius = config.views.color.radius + ((i/length)*config.views.color.radiusGrowth);
            const itemRadius = item.element.geometry.boundingSphere.radius;
            
            const hypothenuse = Math.hypot(radius, itemRadius);
            const rad = Math.sin(itemRadius/hypothenuse);

            totalRad += rad;
            
            const x = Math.sin(totalRad) * radius;
            const y = (-0.5 + (i/length))*config.views.color.height;
            const z = Math.cos(totalRad) * radius;

            item.desiredPosition = new THREE.Vector3(x,y,z);

            if(isInitial) {
                item.currentPosition = item.desiredPosition;
                item.currentRotation = item.desiredRotation;
            }

            totalRad += rad;
        });
        this.totalRad = totalRad;
    },

    /**
     * @param i {float} currentCameraIndex
     * @param cameraWrap {Object} [THREE.js CameraWrap]
     * @param camera {Object} [THREE.js Camera]
     */
    lerpCamera(i) {

        this.lastCameraNormal = i;

        const rad = i * this.totalRad;
        const radius = config.views.color.radius*2 + (i*config.views.color.radiusGrowth);

        const x = Math.sin(rad) * radius;
        const y = (-0.5 + i)*config.views.color.height;
        const z = Math.cos(rad) * radius;

        const position = new THREE.Vector3(x, y, z);
        return position;
    }
}